export const enClientPortalValuationOverviewPageCommon = {
    emptyStateTitle: 'No data found for this asset',
    formulas: {
        grossInitialYield: '\\frac{\\text{Contract rent} \\times 100}{\\text{Market value}}',
        grossYield: '\\frac{\\text{Market rent} \\times 100}{\\text{Market value}}',
    },
}
